<template>
    <div v-if="featured" class="featured">
        <page-cover
            v-if="featured.CoverImage"
            :img="featured.CoverImage?.url ?? ''"
            :title="featured.Title"
        />
        <section v-if="featured.Description" class="section-bg">
            <div
                class="md:container mx-auto px-4 lg:px-12 py-8 md:py-12 lg:py-24"
            >
                <div class="text-center">
                    <rich-text :text="featured.Description" />
                </div>
            </div>
        </section>
        <div
            v-if="featured.OtherInfo && featured.OtherInfo.length > 0"
            class="py-4 md:py-6 lg:py-12"
        >
            <div v-for="(info, index) in featured.OtherInfo" :key="index">
                <section v-if="index % 2 === 0">
                    <div
                        class="md:container mx-auto px-4 lg:px-12 py-4 md:py-6 lg:py-12"
                    >
                        <image-block
                            :title="info.Title"
                            :image-url="info.Image?.url ?? ''"
                            :description="info.Description"
                            :link-url="info.LinkUrl"
                            :link-text="info.LinkText"
                            :flip="false"
                        />
                    </div>
                </section>
                <section v-if="index % 2 === 1">
                    <div
                        class="md:container mx-auto px-4 lg:px-12 py-4 md:py-6 lg:py-12"
                    >
                        <image-block
                            :title="info.Title"
                            :image-url="info.Image?.url ?? ''"
                            :description="info.Description"
                            :flip="true"
                            :link-url="info.LinkUrl"
                            :link-text="info.LinkText"
                        />
                    </div>
                </section>
            </div>
        </div>
        <section v-if="featured.MoreDetails" class="section-bg">
            <div
                class="md:container mx-auto px-4 lg:px-12 py-8 md:py-12 lg:py-24"
            >
                <div>
                    <rich-text :text="featured.MoreDetails" />
                </div>
            </div>
        </section>
        <section v-if="featured.FurtherDetails">
            <div
                class="md:container mx-auto px-4 lg:px-12 py-8 md:py-12 lg:py-24"
            >
                <h3
                    class="text-2xl lg:text-5xl text-primary font-semibold tracking-wide text-center"
                >
                    {{ featured.FurtherDetails.Title }}
                </h3>
                <rich-text
                    v-if="featured.FurtherDetails.Description"
                    :text="featured.FurtherDetails.Description"
                    class="text-center mt-4"
                />
                <div
                    class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-8 lg:mt-16"
                >
                    <sales-block
                        v-for="(item, index) in featured.FurtherDetails
                            .Contents"
                        :key="index"
                        :title="item.Title"
                        :description="item.Subtitle"
                        :image="item.Image"
                        :link-url="item.Link"
                    />
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
const config = useRuntimeConfig();
const route = useRoute();
const featured = ref(null);
const { data: response, error } = await useFetch(
    config.public.baseURl + '/featureds',
    {
        query: { Slug: route.params.id },
    }
);
featured.value = response.value[0];
if (error.value || response.value.length === 0) {
    if (error.value) {
        throw createError({
            ...error.value,
            statusMessage: 'Page Not Found',
        });
    }
    throw showError({
        statusCode: 404,
        statusMessage: 'Page Not Found',
    });
}
useHead({
    title: featured && featured.value ? featured.value.Title : '',
});
</script>

<style lang="scss" scoped>
.featured {
    :deep() {
        .rich-text {
        }
    }
}
</style>
